import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMagicWandStick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 2C15.5 1.58579 15.1642 1.25 14.75 1.25C14.3358 1.25 14 1.58579 14 2V4C14 4.41421 14.3358 4.75 14.75 4.75C15.1642 4.75 15.5 4.41421 15.5 4V2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4697 3.46967C19.7626 3.17678 20.2374 3.17678 20.5303 3.46967C20.8232 3.76256 20.8232 4.23744 20.5303 4.53033L19.0303 6.03033C18.7374 6.32322 18.2626 6.32322 17.9697 6.03033C17.6768 5.73744 17.6768 5.26256 17.9697 4.96967L19.4697 3.46967Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 8.5H22C22.4142 8.5 22.75 8.83579 22.75 9.25C22.75 9.66421 22.4142 10 22 10H20C19.5858 10 19.25 9.66421 19.25 9.25C19.25 8.83579 19.5858 8.5 20 8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.594 7.40546C15.5201 6.33152 13.7789 6.33152 12.705 7.40546L2.80546 17.305C1.73151 18.3789 1.73151 20.1201 2.80546 21.194C3.8794 22.268 5.6206 22.268 6.69454 21.194L16.594 11.2945C17.668 10.2206 17.668 8.4794 16.594 7.40546ZM11.6855 10.5462L3.86612 18.3656C3.37796 18.8538 3.37796 19.6452 3.86612 20.1334C4.35427 20.6215 5.14573 20.6215 5.63388 20.1334L13.4533 12.314L11.6855 10.5462ZM14.514 11.2533L12.7462 9.48554L13.7656 8.46612C14.2538 7.97797 15.0452 7.97797 15.5334 8.46612C16.0215 8.95428 16.0215 9.74573 15.5334 10.2339L14.514 11.2533Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconMagicWandStick as ReactComponent };
